import { Card, CardItem, Skeleton } from "@walmart-web/livingdesign-components"
import React from "react"
import "./index.scss"

const BenchmarkTableSkeleton = () => {
	return (
		<Card role="skeletonview" className="skeleton-container">
			<CardItem className="card-item">
				<div className="card-header">
					<div className="table-header table-row">
						<Skeleton className="table-data" variant="rounded" />
						<Skeleton className="table-data-bar" variant="rounded" />
						<Skeleton className="table-data" variant="rounded" />
						<Skeleton className="table-data" variant="rounded" />
					</div>
				</div>

				<div className="card-body">
					{[0, 1, 2, 3, 4, 5].map((element) => {
						return (
							<div key={element} className="table-row">
								<Skeleton className="table-data" variant="rounded" />
								<Skeleton className="table-data-bar" variant="rounded" />
								<Skeleton className="table-data" variant="rounded" />
								<Skeleton className="table-data" variant="rounded" />
							</div>
						)
					})}
				</div>
			</CardItem>
		</Card>
	)
}

export default BenchmarkTableSkeleton
